import { createContext, useContext } from "react";
import useWalletLogs from "./use-log";

interface WalletLogContextType extends ReturnType<typeof useWalletLogs> {}

const WalletLogContext = createContext<WalletLogContextType | null>(null);

export const WalletLogProvider: React.FC<React.PropsWithChildren<{}>> = ({
  children,
}) => {
  const value = useWalletLogs();

  return (
    <WalletLogContext.Provider value={value}>
      {children}
    </WalletLogContext.Provider>
  );
};

export const useWalletLogContext = () => {
  const context = useContext(WalletLogContext);
  if (!context) {
    throw new Error("useContext must be used within a WalletLogProvider");
  }
  return context;
};
